export const USER_EXPORT_TASK_NAME = 'user-export-download';
export const USER_EXPORT_FILE_NAME = 'Access-management-users';

export const USER_EXPORT_HEADERS: Record<string, string> = {
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    accountName: 'Account Name',
    vendorName: 'Vendor Name',
    role: 'Role',
    tools: 'Tools',
};
